import { Loading } from '@zopauk/web-ui';

export const LoadingSection = () => (
  <div className="items-center justify-center flex h-full min-h-400">
    <Loading data-automation="LOADING_SPINNER" className="text-primary icon-lg!" />
  </div>
);
